/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import {
  Component, ViewEncapsulation, OnInit, ViewChild, ElementRef, HostListener, AfterViewInit,
  ChangeDetectorRef
} from '@angular/core';
import { UserProfileService } from '../userprofile/userprofile.service';
import { UserProfileResponse } from '../userprofile/userprofileresponse';
import { HttpClient } from '@angular/common/http';
import { Router, NavigationEnd, NavigationExtras, ActivatedRoute } from '@angular/router';
import { StoreItemFilterInfo } from '../../feature/store/model/storeitemfilterinfo';
import { CustomerPreferenceService } from '../../preference/customerpreference.service';
import { CustomerPreferenceResponse } from '../../preference/customerpreference.model';
import { BannerService } from './banner.service';
import { RequestsListResponse } from '../../feature/requests/model/requestslistresponse';
import { AlertService } from '../../../shared/alert/alert.service';
import { LoginService } from '../../../login/login.service';
import { CustomizationEnabledResponse } from '../../../login/model/customizationenabledresponse';
import { CommonConstants } from '../../../common/constants/common-constants';
import { PlatformLocation } from '@angular/common';
import { Subject } from 'rxjs';
import { CustomerPreferenceUtil } from '../../preference/customerpreferenceutil';

declare var $: any;

@Component({
  selector: 'zsd-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'
  ],
  encapsulation: ViewEncapsulation.None
})

export class BannerComponent implements OnInit, AfterViewInit {
  public static DEVICE_WIDTH = 768;

  @ViewChild('navbarToggler', { static: false }) navbarToggler: ElementRef;
  @ViewChild('search', { static: false }) search: ElementRef;
  @ViewChild('alertBar', { static: false }) alertBar: ElementRef;
  @ViewChild('zsdSearchDropdown', { static: false }) zsdSearchDropdown: ElementRef;
  @ViewChild('searchIcon', { static: false }) searchIcon: ElementRef;

  username: string;
  searchTerm = null;
  storeItemFilterInfo: StoreItemFilterInfo = new StoreItemFilterInfo();
  requestsListResponse: RequestsListResponse = new RequestsListResponse();
  canCreateIncidents = false;
  canCreateServiceRequests = false;
  canCreateChangeRequests = false;
  showReportButton = false;
  showStoreNavMenu = false;
  showRequestNavMenu = false;
  canViewIncidents = false;
  canEditIncidents = false;
  canViewServiceRequests = false;
  canEditServiceRequests = false;
  canViewChangeRequests = false;
  canEditChangeRequests = false;
  customizedImage = false;
  collapsedMode = true;
  dateFormat: string;

  showServiceTab: boolean;
  showItemTab: boolean;

  showOutagesTab: boolean;
  canCustomerViewOutages = false;
  canCusotmerViewPlannedOutages = false;



  path: string;
  helpURLData: any;
  helpURL: string;
  baseURL: string;
  useCustomEnabled: boolean;
  zsdLogoSrc: string;
  customizationEnabled: boolean;
  imageLoaded = false;
  searchPage = '';
  searchPageString = '';
  searchPlaceholderonExpand = '';
  defaultSearchPageString = '';
  showGolbalSearchBar = true;

  public static refreshGlobalSearchDropdown: Subject<any> = new Subject();

  constructor(private userProfileService: UserProfileService, private http: HttpClient,
    private router: Router, public customerPreferenceService: CustomerPreferenceService,
    private bannerService: BannerService, private alertService: AlertService,
    public loginService: LoginService, private ref: ChangeDetectorRef, private route: ActivatedRoute,
    private location: PlatformLocation, public customerPreference: CustomerPreferenceUtil) {

    // AOT Changes - Vaibhav
    this.location.onPopState(() => {
      $('#zsd_modal_new_request').modal('hide');
      this.ngOnInit();
    });

    // AOT Changes - Vaibhav
    this.location.onHashChange(() => {
      this.ngOnInit();
    });

    BannerComponent.refreshGlobalSearchDropdown.subscribe(() => {
      this.customerPreference.setPrivilgesBasedPreferences();
      this.ngOnInit();
      this.onResize();
    });

    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        this.showGolbalSearchBar = true;
      }
    });
  }

  ngOnInit() {
    this.hideNavbarMenuList();
    setTimeout(function () {
      let viewheight = $(window).height();
      let viewwidth = $(window).width();
      let viewport = document.querySelector('meta[name=viewport]');
      viewport.setAttribute('content', 'height=' + viewheight + 'px, width=' + viewwidth + 'px, initial-scale=1.0');
    }, 300);

    this.userProfileService.getUserprofile().subscribe(
      (user: UserProfileResponse) => {
        this.username = user.fullName;
      },
      () => {
        return null;
      }
    );
    this.customerPreferenceService
      .getPreferenceList()
      .subscribe((preference: CustomerPreferenceResponse) => {
        // privilege check for report an incident button
        this.canCreateIncidents = preference.canCreateIncidents;
        this.canCreateServiceRequests = preference.canCreateServiceRequests;
        this.canCreateChangeRequests = preference.canCreateChangeRequests;
        if (this.canCreateIncidents || this.canCreateServiceRequests || this.canCreateChangeRequests) {
          this.showReportButton = true;
          this.dateFormat = preference.dateFormat;
        }
        localStorage.setItem('dateFormat', this.dateFormat);

        // privilege check to show store tab
        this.showStoreNavMenu = preference.appStoreCustomerEnable;
        if (this.showStoreNavMenu) {
          this.showStoreNavMenu = true;
        }

        // privilege check to show  request tab
        this.canViewIncidents = preference.canViewIncidents;
        this.canEditIncidents = preference.canEditIncidents;
        this.canViewServiceRequests = preference.canViewServiceRequests;
        this.canEditServiceRequests = preference.canEditServiceRequests;
        this.canViewChangeRequests = preference.canViewChangeRequests;
        this.canEditChangeRequests = preference.canEditChangeRequests;

        if (this.canViewIncidents || this.canEditIncidents || this.canViewServiceRequests ||
          this.canEditServiceRequests || this.canViewChangeRequests || this.canEditChangeRequests) {
          this.showRequestNavMenu = true;
        }

        // privilege check to show service tab
        this.showServiceTab = preference.showService;

        this.showItemTab = preference.canViewItems;

        // privilege check to show outags tab
        this.canCustomerViewOutages = preference.canCustomerViewOutages;
        this.canCusotmerViewPlannedOutages = preference.canCusotmerViewPlannedOutages;
        if (this.canCustomerViewOutages || this.canCusotmerViewPlannedOutages) {
          this.showOutagesTab = true;
        }
      },
        () => {
          return null;
        }
      );

    this.loginService.isCustomizeEnabled().subscribe(
      (response: CustomizationEnabledResponse) => {
        this.customizationEnabled = response.customizeEnabled;
        if (this.customizationEnabled) {
          this.customizedImage = true;  // Making Flag customizedImage true if Use Custom is enabled
          this.zsdLogoSrc = '../LiveTime/images/banners/custom/custom_eupClientLogo.png';
        } else {
          this.zsdLogoSrc = 'img/ZSD_logo.png';
        }
        this.imageLoaded = true;
      },
      err => {
        console.error('Error occurred while fetching use customization enabled or not value');
        console.error(err.error);
      }
    );
    this.router.events.subscribe((event) => {
      this.path = this.router.url;
      this.baseURL = this.helpURLData.baseHelpUrl;
      // this.setSearchPage();
      if (this.path.search(CommonConstants.HOME_COMPONENT) !== -1) {
        this.helpURL = this.baseURL + this.helpURLData.homeHelpId;
      }
      if (this.path.search(CommonConstants.STORE_COMPONENT) !== -1) {
        this.helpURL = this.baseURL + this.helpURLData.storeHelpId;
      }
      if (this.path.search(CommonConstants.REQUEST_COMPONENT) !== -1) {
        this.helpURL = this.baseURL + this.helpURLData.requestsHelpId;
      }
      if (this.path.search(CommonConstants.REQUEST_COMPONENT) !== -1) {
        this.helpURL = this.baseURL + this.helpURLData.requestsHelpId;
      }
      if (this.path.search(CommonConstants.ITEMS_COMPONENT) !== -1) {
        this.helpURL = this.baseURL + this.helpURLData.itemsHelpId;
      }
      if (this.path.search(CommonConstants.SERVICES_COMPONENT) !== -1) {
        this.helpURL = this.baseURL + this.helpURLData.servicesHelpId;
      }
      if (this.path.search(CommonConstants.SELFHELP_COMPONENT) !== -1) {
        this.helpURL = this.baseURL + this.helpURLData.selfHelpId;
      }
      if (this.path.search(CommonConstants.OUTAGES_COMPONENT + CommonConstants.CURRENT_OUTAGES_COMPONENT) !== -1) {
        this.helpURL = this.baseURL + this.helpURLData.outageshelpId;
      }
      if (this.path.search(CommonConstants.OUTAGES_COMPONENT + CommonConstants.PLANNED_OUTAGES_COMPONENT) !== -1) {
        this.helpURL = this.baseURL + this.helpURLData.plannedOutagesHelpId;
      }
      if (this.path === '/my-profile') {
        this.helpURL = this.baseURL + this.helpURLData.userprofileHelpId;
      }
      // if (this.path === '/report-incident') {
      //   this.helpURL = this.baseURL + this.helpURLData.creatingRequestHelpId;
      // }
      if (event instanceof NavigationEnd) {   /// shivam
        /* if (this.path === '/search') {
          this.requestlistSearchService.applyRequestSearchFilter(this.requestsListResponse);
          this.storeFilterService.applySearchFilter(this.storeItemFilterInfo);
        } */
      }
      // this.chooseSearchPage(this.searchPage);
    });


    this.bannerService.getHelpURL()
      .subscribe((value) => {
        this.path = this.router.url;

        this.helpURLData = value;
        this.baseURL = this.helpURLData.baseHelpUrl;
        if (this.path.search(CommonConstants.HOME_COMPONENT) !== -1) {
          this.helpURL = this.baseURL + this.helpURLData.homeHelpId;
        }
        if (this.path.search(CommonConstants.STORE_COMPONENT) !== -1) {
          this.helpURL = this.baseURL + this.helpURLData.storeHelpId;
        }
        if (this.path.search(CommonConstants.ITEMS_COMPONENT) !== -1) {
          this.helpURL = this.baseURL + this.helpURLData.itemsHelpId;
        }
        if (this.path.search(CommonConstants.SERVICES_COMPONENT) !== -1) {
          this.helpURL = this.baseURL + this.helpURLData.servicesHelpId;
        }
        if (this.path.search(CommonConstants.REQUEST_COMPONENT) !== -1) {
          this.helpURL = this.baseURL + this.helpURLData.requestsHelpId;
        }
        if (this.path.search(CommonConstants.SELFHELP_COMPONENT) !== -1) {
          this.helpURL = this.baseURL + this.helpURLData.selfHelpId;
        }
        if (this.path.search(CommonConstants.OUTAGES_COMPONENT + CommonConstants.CURRENT_OUTAGES_COMPONENT) !== -1) {
          this.helpURL = this.baseURL + this.helpURLData.outagesHelpId;
        }
        if (this.path.search(CommonConstants.OUTAGES_COMPONENT + CommonConstants.PLANNED_OUTAGES_COMPONENT) !== -1) {
          this.helpURL = this.baseURL + this.helpURLData.plannedOutagesHelpId;
        }
        if (this.path === '/my-profile') {
          this.helpURL = this.baseURL + this.helpURLData.userprofileHelpId;
        }
        if (this.path === '/report-incident') {
          this.helpURL = this.baseURL + this.helpURLData.reportIncidentHelpId;
        }
        /* if (this.searchPage !== 'all') {
          this.chooseSearchPage('current');
        } */
      });

    this.setSearchPage();

    this.route.queryParams.subscribe(params => {
      if (params['searchTerm']) {
        this.searchTerm = JSON.parse(params['searchTerm']);
        this.collapsedMode = false;
      }
    });

    if (this.path.search(CommonConstants.STORE_COMPONENT) !== -1) {
      this.initSearchPage('store', 'Banner.store', 'Banner.searchstore', 'Banner.searchPlaceholder');
    }
    if (this.path.search(CommonConstants.REQUEST_COMPONENT) !== -1) {
      this.initSearchPage('requests', 'Banner.requests', 'Banner.searchrequests', 'Banner.searchPlaceholder');
    }
    if (this.path.search(CommonConstants.SERVICES_COMPONENT) !== -1) {
      this.initSearchPage('services', 'Banner.services', 'Banner.searchservices', 'Banner.searchPlaceholder');
    }
    if (this.path.search(CommonConstants.SELFHELP_COMPONENT) !== -1) {
      this.initSearchPage('selfhelp', 'Banner.selfhelp', 'Banner.searchselfhelp', 'Banner.searchPlaceholder');
    }
    if (this.path.search(CommonConstants.ITEMS_COMPONENT) !== -1) {
      this.initSearchPage('items', 'Banner.items', 'Banner.searchitems', 'Banner.searchPlaceholder');
    }
    if (this.path.search(CommonConstants.OUTAGES_COMPONENT + CommonConstants.CURRENT_OUTAGES_COMPONENT) !== -1) {
      this.initSearchPage('currentoutages', 'Banner.outages', 'Banner.searchoutages', 'Banner.searchPlaceholder');
    }
    if (this.path.search(CommonConstants.OUTAGES_COMPONENT + CommonConstants.PLANNED_OUTAGES_COMPONENT) !== -1) {
      this.initSearchPage('plannedoutages', 'Banner.plannedOutages', 'Banner.searchplannedOutages', 'Banner.searchPlaceholder');
    }
    if (this.path.search(CommonConstants.MYPROFILE_COMPONENT) !== -1) {
      this.initSearchPage('my-profile', '', '', '');
    }
    if (this.path.search(CommonConstants.NEWREQUEST_COMPONENT) !== -1) {
      this.initSearchPage('newrequest', '', '', '');
    }
    if (this.path.search(CommonConstants.HOME_COMPONENT) !== -1) {
      this.showGolbalSearchBar = false;
    }
  }

  initSearchPage(searchPage: string, searchPageString: string, defaultSearchPageString: string, searchPlaceholderonExpand: string) {
    this.searchPage = searchPage;
    this.searchPageString = searchPageString;
    this.defaultSearchPageString = defaultSearchPageString;
    this.searchPlaceholderonExpand = searchPlaceholderonExpand;
    if (window.innerWidth <= BannerComponent.DEVICE_WIDTH) {
      this.searchPageString = '';
      this.searchPlaceholderonExpand = defaultSearchPageString;
    }
  }

  setSearchPage() {
    this.path = this.router.url;
    if (this.path.search(CommonConstants.STORE_COMPONENT) !== -1) {
      this.chooseSearchPage('store');
    }
    if (this.path.search(CommonConstants.SERVICES_COMPONENT) !== -1) {
      this.chooseSearchPage('services');
    }
    if (this.path.search(CommonConstants.REQUEST_COMPONENT) !== -1) {
      this.chooseSearchPage('requests');
    }
    if (this.path.search(CommonConstants.SELFHELP_COMPONENT) !== -1) {
      this.chooseSearchPage('selfhelp');
    }
    if (this.path.search(CommonConstants.ITEMS_COMPONENT) !== -1) {
      this.chooseSearchPage('items');
    }
    if (this.path.search(CommonConstants.OUTAGES_COMPONENT + CommonConstants.CURRENT_OUTAGES_COMPONENT) !== -1) {
      this.chooseSearchPage('currentoutages');
    }
    if (this.path.search(CommonConstants.OUTAGES_COMPONENT + CommonConstants.PLANNED_OUTAGES_COMPONENT) !== -1) {
      this.chooseSearchPage('plannedoutages');
    }
    if (this.path.search(CommonConstants.NEWREQUEST_COMPONENT) !== -1) {
      this.chooseSearchPage('newrequest');
    }
    if (this.path.search(CommonConstants.MYPROFILE_COMPONENT) !== -1) {
      this.chooseSearchPage('my-profile');
    }
    if (this.path.search(CommonConstants.HOME_COMPONENT) !== -1) {
      this.chooseSearchPage('home');
    }
  }

  navBarTogglerIsVisible() {
    return this.navbarToggler.nativeElement.offsetParent !== null;
  }

  collapseNav(id: String) {
    let searchPageUrl: string;
    if (this.navBarTogglerIsVisible()) {
      this.navbarToggler.nativeElement.click();
    }
    if (id === 'zsd_home') {
      this.searchTerm = '';
      this.chooseSearchPage('home');
      searchPageUrl = CommonConstants.HOME_COMPONENT;
      this.showGolbalSearchBar = false;
      this.deleteAlert();
    }
    if (id === 'zsd_store' || id === 'zsd_logo') {
      this.searchTerm = null;
      this.chooseSearchPage('store');
      searchPageUrl = CommonConstants.STORE_COMPONENT;
    }
    if (id === 'zsd_requests') {
      this.searchTerm = null;
      this.chooseSearchPage('requests');
      searchPageUrl = CommonConstants.REQUEST_COMPONENT;

    }
    if (id === 'zsd_services') {
      this.searchTerm = '';
      this.chooseSearchPage('services');
      searchPageUrl = CommonConstants.SERVICES_COMPONENT;

    }
    if (id === 'zsd_selfhelp') {
      this.searchTerm = '';
      this.chooseSearchPage('selfhelp');
      searchPageUrl = CommonConstants.SELFHELP_COMPONENT;

    }
    if (id === 'zsd_items') {
      this.searchTerm = '';
      this.chooseSearchPage('items');
      searchPageUrl = CommonConstants.ITEMS_COMPONENT;

    }
    if (id === 'zsd_outages') {
      this.searchTerm = '';
      this.chooseSearchPage('currentoutages');
      searchPageUrl = CommonConstants.OUTAGES_COMPONENT;

    }
    if (id === 'zsd_reportIncident') {
      this.searchTerm = '';
      this.chooseSearchPage('newrequest');
      searchPageUrl = CommonConstants.NEWREQUEST_COMPONENT;

    }
    if (id === 'zsd-profile') {
      this.searchTerm = '';
      this.chooseSearchPage('my-profile');
      searchPageUrl = CommonConstants.MYPROFILE_COMPONENT;

    }
    this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
    this.router.navigate([searchPageUrl]));
  }

  // removing alert after incident creation
  deleteAlert() {
    this.alertService.delAlert();
  }

  loadEnabledTab(id: String) {
    if (id === 'zsd_logo') {
      this.searchTerm = null;
    }
    let privilegeEnabledTab: Array<string> = JSON.parse(localStorage.getItem('cusPref'));
    this.router.navigate([privilegeEnabledTab[0]]);
  }

  logOut() {
    this.getLogOutService().subscribe(
      () => {
        localStorage.clear();
        this.router.navigate(['/login']);
      },
      () => {
        localStorage.clear();
        this.router.navigate(['/login']);
      }
    );

  }

  loadNewRequestCreationPage() {
    this.searchTerm = '';
    this.chooseSearchPage('newrequest');
    let searchPageUrl = CommonConstants.NEWREQUEST_COMPONENT;
    this.showGolbalSearchBar = true;
    this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
      this.router.navigate([searchPageUrl]));
  }

  getLogOutService() {
    return this.http.post(CommonConstants.SERVICE_VERSION_PATH_V1 + '/auth/logout', null);
  }

  clickSearch() {
    console.log('search term:' + this.searchTerm);
    if (this.searchTerm === '') {
      this.searchTerm = null;
    }
    if (this.searchTerm !== null) {
      this.searchTerm = JSON.stringify(this.searchTerm);
    }
    let navigationExtras: NavigationExtras = {
      queryParams: {
        'searchTerm': this.searchTerm
      },
      queryParamsHandling: 'merge'
    };
    if (this.searchPage === 'store') {
      this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
        this.router.navigate([CommonConstants.STORE_COMPONENT], navigationExtras));
    } else if (this.searchPage === 'services') {
      this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
        this.router.navigate([CommonConstants.SERVICES_COMPONENT], navigationExtras));
    } else if (this.searchPage === 'requests') {
      this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
        this.router.navigate([CommonConstants.REQUEST_COMPONENT], navigationExtras));
    } else if (this.searchPage === 'selfhelp') {
      this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
        this.router.navigate([CommonConstants.SELFHELP_COMPONENT], navigationExtras));
    } else if (this.searchPage === 'items') {
      this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
        this.router.navigate([CommonConstants.ITEMS_COMPONENT], navigationExtras));
    } else if (this.searchPage === 'currentoutages') {
      this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
        this.router.navigate([CommonConstants.OUTAGES_COMPONENT + CommonConstants.CURRENT_OUTAGES_COMPONENT], navigationExtras));
    } else if (this.searchPage === 'plannedoutages') {
      this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
        this.router.navigate([CommonConstants.OUTAGES_COMPONENT + CommonConstants.PLANNED_OUTAGES_COMPONENT], navigationExtras));
    } else if (this.searchPage === 'newrequest') {
      this.searchTerm = '';
      this.router.navigate([CommonConstants.NEWREQUEST_COMPONENT]);
    } else if (this.searchPage === 'my-profile') {
      this.searchTerm = '';
      this.router.navigate([CommonConstants.MYPROFILE_COMPONENT]);
    } else if (this.searchPage === 'home') {
      this.searchTerm = '';
      this.router.navigate([CommonConstants.HOME_COMPONENT]);
    }
  }

  chooseSearchPage(page) {
    this.searchPage = page;
    if (this.searchPage === 'store') {
      this.initSearchPage('store', 'Banner.store', 'Banner.searchstore', 'Banner.searchPlaceholder');
    } else if (this.searchPage === 'services') {
      this.initSearchPage('services', 'Banner.services', 'Banner.searchservices', 'Banner.searchPlaceholder');
    } else if (this.searchPage === 'requests') {
      this.initSearchPage('requests', 'Banner.requests', 'Banner.searchrequests', 'Banner.searchPlaceholder');
    } else if (this.searchPage === 'selfhelp') {
      this.initSearchPage('selfhelp', 'Banner.selfhelp', 'Banner.searchselfhelp', 'Banner.searchPlaceholder');
    } else if (this.searchPage === 'items') {
      this.initSearchPage('items', 'Banner.items', 'Banner.searchitems', 'Banner.searchPlaceholder');
    } else if (this.searchPage === 'currentoutages') {
      this.initSearchPage('currentoutages', 'Banner.outages', 'Banner.searchoutages', 'Banner.searchPlaceholder');
    } else if (this.searchPage === 'plannedoutages') {
      this.initSearchPage('plannedoutages', 'Banner.plannedOutages', 'Banner.searchplannedOutages', 'Banner.searchPlaceholder');
    } else if (this.searchPage === 'newrequest') {
      this.initSearchPage('newrequest', '', '', '');
    } else if (this.searchPage === 'my-profile') {
      this.initSearchPage('my-profile', '', '', '');
    } else if (this.searchPage === 'home') {
      this.initSearchPage('home', '', '', '');
    }
    this.ref.detectChanges();
    // this.dropdownPadding = this.zsdSearchDropdown.nativeElement.offsetWidth + 'px';

  }

  expandSearchbar() {
    $('#zsd_searchexpand input[type=search]').focus();
  }

  searchBarExpand() {
    this.collapsedMode = false;
    setTimeout(() => {
      $('#inputbox_expand').focus();
    }, 100);

    if (window.innerWidth <= BannerComponent.DEVICE_WIDTH) {
      $('#zsd_reportIncident_icon').css({ 'display': 'none' });
    }
  }

  searchBarInExpandedView() {
    this.collapsedMode = false;
    $('#zsd_search input[type=search]').focus();
  }

  searchBarInCollapsedView() {
    this.collapsedMode = true;
    this.searchTerm = null;
    let reloadPageUrl: string;
    if (this.searchPage === 'store') {
      reloadPageUrl = CommonConstants.STORE_COMPONENT;
    } if (this.searchPage === 'services') {
      reloadPageUrl = CommonConstants.SERVICES_COMPONENT;
    } if (this.searchPage === 'requests') {
      reloadPageUrl = CommonConstants.REQUEST_COMPONENT;
    } if (this.searchPage === 'selfhelp') {
      reloadPageUrl = CommonConstants.SELFHELP_COMPONENT;
    } if (this.searchPage === 'items') {
      reloadPageUrl = CommonConstants.ITEMS_COMPONENT;
    } if (this.searchPage === 'currentoutages') {
      reloadPageUrl = CommonConstants.OUTAGES_COMPONENT + CommonConstants.CURRENT_OUTAGES_COMPONENT;
    } if (this.searchPage === 'plannedoutages') {
      reloadPageUrl = CommonConstants.OUTAGES_COMPONENT + CommonConstants.PLANNED_OUTAGES_COMPONENT;
    }
    if (this.searchPage === 'newrequest') {
      reloadPageUrl = CommonConstants.NEWREQUEST_COMPONENT;
    }
    if (this.searchPage === 'my-profile') {
      reloadPageUrl = CommonConstants.MYPROFILE_COMPONENT;
    }
    if (this.searchPage === 'home') {
      reloadPageUrl = CommonConstants.HOME_COMPONENT;
    }
    let navigationExtras: NavigationExtras = {
      queryParams: {
        'searchTerm': this.searchTerm
      },
    };
    this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
      this.router.navigate([reloadPageUrl], navigationExtras));
    if (window.innerWidth <= BannerComponent.DEVICE_WIDTH) {
      $('#zsd_reportIncident_icon').css({ 'display': 'block' });
    }
  }

  // this hides hamburger menu list in mobile/tablet if clicked outside of it
  hideNavbarMenuList() {
    $(document).click(function (event) {
      let clickover = $(event.target);
      let opened = $('.navbar-collapse').hasClass('navbar-collapse');
      if (opened === true && !clickover.hasClass('navbar-toggler')) {
        $('.navbar-collapse').collapse('hide');
      }
    });
  }

  // search bar
  @HostListener('window:resize') onResize() {
    this.showGolbalSearchBar = true;
    if (window.innerWidth > 992 && (this.path.search(CommonConstants.HOME_COMPONENT) !== -1)) {
      this.showGolbalSearchBar = false;
    }
  }

  ngAfterViewInit() {
    this.onResize();
  }
  gotoDefaultPage() {
    this.searchTerm = '';
    let privilegeEnabledTab: Array<string> = JSON.parse(localStorage.getItem('cusPref'));
    this.router.navigate([privilegeEnabledTab[JSON.parse(localStorage.getItem('defaultTab'))]]);
  }
}
